import { render, staticRenderFns } from "./SalesInvoices.vue?vue&type=template&id=59f30fea"
import script from "./SalesInvoices.vue?vue&type=script&lang=js"
export * from "./SalesInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports